import { Model, createRecipe } from 'sunlife-domain'

import { attributeSelectionComponent } from '@salsita-ai/platform-project-sdk/domain'

import { configuratorInterface } from '../systems/configurator-interface'

export const replaceSunlifeShortsOnPatternChange = configuratorInterface.transformerBuilder.when
  .component([attributeSelectionComponent])
  .instance(['pattern'])
  .modified.onEntity(Model.SunlifeShorts.types)
  .then.overrideMatchingUpdate(ctx => {
    const { id, type, ...data } = ctx.getOld$Entity()._raw
    const replacementEntity = createRecipe({
      type: ctx.update.writableState.value as (typeof Model.SunlifeShorts.types)[number],
      ...data,
    })

    return [
      configuratorInterface.updates.DomainEntityReplacement({
        entityId: ctx.getOld$Entity().id,
        replacementEntity,
        updateTag: 'replaceSunlifeShortsOnPatternChange',
        keepChildren: true,
      }),
      ctx.domainContext.navigationSystem.getSelectUpdate(replacementEntity.id),
    ]
  })
  .build('replaceSunlifeShortsOnPatternChange')
